import React, { Fragment, useContext, useEffect, useState } from "react";

import IconLocation from "../../resources/images/icon/icon_location_line.png";
import IconPolygon from "../../resources/images/icon/newIcon/polygon.svg";

import dayjs from "dayjs";
import { Base64, encodeURI } from "js-base64";
import { AppContext } from "../../components/AppProvider";
import { _O } from "../../modules/utils";
import {
  changeDateFormat,
  checkDateNow,
  stringToTelNo,
} from "../../modules/utils/CheckLogic";
import { getAccessTokenApi } from "../../modules/utils/ZoomApi";
import {
  Button,
  CommentDiv,
  FlexDiv,
  TextTitle,
} from "../Nftf/MedicalCard/MedicalCardStyle";
import CardStatus from "./CardStatus";
import ChevronDown from "../../resources/images/icon/chevron-down.svg";
import ChevronUp from "../../resources/images/icon/chevron-up.svg";
import a from "../../resources/images/nftf/exclamation-circle.svg";
import {
  BottomShortBtn,
  CardArea,
  CardStatusArea,
  ContentTd,
  HsptTitle,
  PayCardInfo,
  PayPrice,
  PayResult,
  SeparateLine,
  StatusArea,
  StatusDiv,
  StatusIcon,
  StatusText,
  TitleTd,
} from "./ReserveStyle";
import { PostApi1970, postZoomSessionId } from "../../modules/network/padoPost";

const ReserveCard = props => {
  const {
    data,
    mapLayer,
    handleConfirm,
    resrvCancelLayer,
    handleDialog,
    setPharmInfo,
    setModifyMode,
    nftfConnect,
    setNftfConnect,
    setResrvList,
  } = props;
  const [rejctRsnToggle, setRejctRsnToggle] = useState(true);
  const [delayRsnToggle, setDelayRsnToggle] = useState(true);
  const [toggleView, setToggleView] = useState(false);
  const [delayToggleView, setDelayToggleView] = useState(false);
  const { dispatch, userinfo } = useContext(AppContext);

  // appStatus 1:신청 2:접수중 3.접수4.확정요청7:접수완료 8:병원마감 9:취소
  // appStatus == 7 && telMdcnOpenToDh == true && telMdcnOpenToDh != "" --> 진료종료 상태
  const changeDateFormat2 = date => {
    const returnDate =
      date.length == 8
        ? dayjs(date).format("YYYYMMDD").format("YYYY.MM.DD")
        : dayjs(date, "YYYYMMDDHHmm").format("YYYY-MM-DD HH:mm");
    return returnDate;
  };

  useEffect(() => {
    // 지연사유
    if (data.delayRsn) {
      if (
        $("#delayRsn" + data.resrvNo).outerWidth() <
        $("#delayRsn" + data.resrvNo)[0].scrollWidth
      ) {
        setDelayToggleView(true);
      }
    }

    if (
      (data.appStatus === "1" ||
        data.appStatus === "4" ||
        data.appStatus === "7") &&
      data.appComm
    ) {
      if (
        $("#resrvInfo" + data.resrvNo).outerWidth() <
        $("#resrvInfo" + data.resrvNo)[0].scrollWidth
      ) {
        {
          setToggleView(true);
        }
      }
    }

    // 반려사유
    if (data.appStatus === "10") {
      if (
        $("#rejctRsnText" + data.resrvNo).outerWidth() <
        $("#rejctRsnText" + data.resrvNo)[0].scrollWidth
      ) {
        setToggleView(true);
      }
    }
  }, []);

  return (
    <Fragment>
      {/* <CardArea id={data.appCls + '_' + data.appID}> */}
      <CardArea id={data.appCls + "_" + data.appID}>
        <CardStatusArea>
          {/* {data.appStatue != 8 || data.appStatue != 9 ? ( */}
          <CardStatus data={data} />
        </CardStatusArea>
        <SeparateLine />
        {/* 병원정보 START*/}
        <HsptTitle>
          {data.hospital[0].hpName}
          {data.appCls != "1" ? (
            <img
              src={IconLocation}
              style={{ width: "15px", height: "20px" }}
              onClick={() =>
                mapLayer(
                  data.hpName,
                  data.hospital[0].latitude,
                  data.hospital[0].longitude,
                  data.hospital[0]
                )
              }
            />
          ) : data.appStatus != "9" &&
            checkDateNow(data.appTime) &&
            data.payStatus != "1" ? (
            <PayCardInfo
              onClick={() => {
                _O.Open(
                  "/nftf/index/" +
                    Base64.encode(JSON.stringify(data.hospital[0])) +
                    "/1/" +
                    data.appID +
                    "/" +
                    data.appStatus
                );
                dispatch({ type: "SET_NFTF_DOCTOR", data: null });
              }}>
              예약정보 수정
            </PayCardInfo>
          ) : null}
        </HsptTitle>
        <FlexDiv>
          <table
            style={{
              wordBreak: "keep-all",
              tableLayout: "fixed",
              width: "100%",
            }}>
            <colgroup>
              <col width="20%" />
              <col width="80%" />
            </colgroup>
            <tbody>
              <tr>
                <TitleTd>이름</TitleTd>
                <ContentTd>
                  {data.rqstRelCd === "FAMZ" ? data.famzNm : userinfo.userName}
                </ContentTd>
              </tr>
              {data.resrvNo && (
                <tr>
                  <TitleTd>예약번호</TitleTd>
                  <ContentTd>{data.resrvNo}</ContentTd>
                </tr>
              )}
              <tr>
                <TitleTd>예약일시</TitleTd>
                <ContentTd>
                  <div style={{ display: "flex", gap: "8px" }}>
                    {data.appCls == 1
                      ? changeDateFormat(data.appDelayTime)
                      : changeDateFormat2(data.appTime)}
                  </div>
                </ContentTd>
              </tr>

              {(data.appStatus === "1" ||
                data.appStatus === "4" ||
                data.appStatus === "5" ||
                data.appStatus === "7") &&
              data.appComm ? (
                <tr>
                  <TitleTd>접수정보</TitleTd>
                  <ContentTd onClick={() => setRejctRsnToggle(!rejctRsnToggle)}>
                    <div
                      id={"resrvInfo" + data.resrvNo}
                      style={rejctRsnToggle ? skipTextCss : defaultTextCss}>
                      {data.appComm}
                    </div>
                    {toggleView && (
                      <img
                        src={rejctRsnToggle ? ChevronDown : ChevronUp}
                        style={{ height: "20px" }}
                      />
                    )}
                  </ContentTd>
                </tr>
              ) : null}

              {data.delayRsn ? (
                <tr>
                  <TitleTd>변경사유</TitleTd>
                  <ContentTd onClick={() => setDelayRsnToggle(!delayRsnToggle)}>
                    <div
                      id={"delayRsn" + data.resrvNo}
                      style={delayRsnToggle ? skipTextCss : defaultTextCss}>
                      {data.delayRsn}
                    </div>
                    {delayToggleView && (
                      <img
                        src={delayRsnToggle ? ChevronDown : ChevronUp}
                        style={{ height: "20px" }}
                      />
                    )}
                  </ContentTd>
                </tr>
              ) : null}

              {(data.appStatus === "10" || data.appStatus === "9") &&
              data.rejctRsn &&
              data.rejctRsn != "" ? (
                <tr>
                  <TitleTd>반려사유</TitleTd>
                  <ContentTd onClick={() => setRejctRsnToggle(!rejctRsnToggle)}>
                    <div
                      id={"rejctRsnText" + data.resrvNo}
                      style={rejctRsnToggle ? skipTextCss : defaultTextCss}>
                      {data.rejctRsn}
                    </div>
                    {toggleView && (
                      <img
                        src={rejctRsnToggle ? ChevronDown : ChevronUp}
                        style={{ height: "20px" }}
                      />
                    )}
                  </ContentTd>
                </tr>
              ) : null}

              <tr>
                <TitleTd>{data.appCls === "9" ? "검사명" : "담당의"}</TitleTd>
                <ContentTd>{data.appDR ? data.appDR : "미지정"}</ContentTd>
              </tr>
              <tr>
                <TitleTd>Tel.</TitleTd>
                <ContentTd>{stringToTelNo(data.hospital[0].phone)}</ContentTd>
              </tr>
            </tbody>
          </table>
        </FlexDiv>
        {/* 병원정보 END*/}
        {(!data.telmdcnToDh || data.telmdcnToDh == "") &&
          data.telmdcnOpenYn === "Y" &&
          data.zoomSessId === "" && (
            <CommentDiv style={{ width: "100%" }}>
              <div style={{ width: "16px", height: "16px" }}>
                <img src={a} />
              </div>
              <div>진료 준비중입니다 잠시 후 다시 시도하세요</div>
            </CommentDiv>
          )}
        {data.appCls === "1" &&
          data.appStatus != "10" &&
          data.appStatus != "9" && (
            <Fragment>
              <SeparateLine />
              <HsptTitle>
                <div>처방전 접수</div>
                <PayCardInfo
                  onClick={() => {
                    setPharmInfo(data);
                    setModifyMode(true);
                  }}>
                  {(data.pharmName || data.pharmFaxNum) &&
                  (data.pharmName != "" || data.pharmFaxNum != "")
                    ? "정보 수정"
                    : "약국 정보 등록"}
                </PayCardInfo>
              </HsptTitle>

              {(data.pharmName || data.pharmFaxNum) &&
                (data.pharmName != "" || data.pharmFaxNum != "") && (
                  <FlexDiv>
                    <table style={{ wordBreak: "keep-all" }}>
                      <tbody>
                        <tr>
                          <TitleTd>약국이름</TitleTd>
                          <ContentTd>{data.pharmName}</ContentTd>
                        </tr>
                        <tr>
                          <TitleTd>전화번호</TitleTd>
                          <ContentTd>
                            {stringToTelNo(data.pharmTelNo)}
                          </ContentTd>
                        </tr>
                        <tr>
                          <TitleTd>Fax</TitleTd>
                          <ContentTd>
                            {stringToTelNo(data.pharmFaxNum)}
                          </ContentTd>
                        </tr>
                      </tbody>
                    </table>
                  </FlexDiv>
                )}

              {/* 결제정보 START */}
              {data.billBtnYn === "Y" && (
                <Fragment>
                  <SeparateLine />
                  <HsptTitle>
                    <div>진료비</div>
                  </HsptTitle>
                  <PayResult>
                    <FlexDiv
                      style={{
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}>
                      <div style={{ display: "flex", gap: "24px" }}>
                        <TextTitle>
                          <div>결제내역</div>
                        </TextTitle>
                        <PayPrice>
                          {parseInt(data.totAmt).toLocaleString("ko-KR", 0) +
                            "원"}
                        </PayPrice>
                      </div>

                      <PayCardInfo
                        onClick={() =>
                          _O.Open(
                            "/nftf/payHistory/" +
                              encodeURI(Base64.encode(JSON.stringify(data)))
                          )
                        }>
                        상세보기
                      </PayCardInfo>
                    </FlexDiv>
                  </PayResult>
                </Fragment>
              )}

              {data.cardChrgYn && data.cardChrgYn === "Y" && (
                <Fragment>
                  <SeparateLine />
                  <HsptTitle>
                    <div>진료비</div>
                  </HsptTitle>
                  <PayResult>
                    <FlexDiv
                      style={{
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}>
                      <div style={{ display: "flex", gap: "24px" }}>
                        <TextTitle>
                          <div>결제내역</div>
                        </TextTitle>
                        <PayPrice>결제실패</PayPrice>
                      </div>

                      <PayCardInfo
                        onClick={() =>
                          _O.Open(
                            "/mp/cardManager/" +
                              Base64.encode(JSON.stringify(data))
                          )
                        }>
                        결제수단 변경
                      </PayCardInfo>
                    </FlexDiv>
                  </PayResult>
                </Fragment>
              )}
              {/* 결제정보 END */}
            </Fragment>
          )}
        <ReserveBottomBtn
          data={data}
          handleConfirm={handleConfirm}
          resrvCancelLayer={resrvCancelLayer}
          handleDialog={handleDialog}
          nftfConnect={nftfConnect}
          setNftfConnect={setNftfConnect}
          setResrvList={setResrvList}
        />
      </CardArea>
    </Fragment>
  );
};

const Status = (props) => {
  return (
    <StatusDiv>
      <StatusIcon image={props.image} />
      <StatusArea>
        {props.active && <img src={IconPolygon} />}
        <StatusText active={props.active}>{props.text}</StatusText>
      </StatusArea>
    </StatusDiv>
  );
};

const ReserveBottomBtn = (props) => {
  const {
    data,
    handleConfirm,
    resrvCancelLayer,
    handleDialog,
    nftfConnect,
    setNftfConnect,
    setResrvList,
  } = props;
  const { userinfo, phonecfg, cfg } = useContext(AppContext);

  const checkTelMdcnDh = (telmdcnFrDh, telmdcnToDh) => {
    if ((telmdcnFrDh && telmdcnToDh) || (!data.telmdcnFrDh && !data.telmdcnToDh)) {
      return true;
    } else {
      return false;
    }
  };

  const checkDateNow = () => {
    if (dayjs(data.appTime).format("YYYYMMDD") === dayjs().format("YYYYMMDD")) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div style={{ width: "100%", display: "flex", gap: "8px" }}>
      {/* {data.appCls == "1" && */}
      {/* !data.telmdcnToDh && */}
      {/* data.telmdcnOpenYn === "Y" && */}
      {/* checkDateNow(data.appTime) ? ( */}
      {data.appCls == "1" &&
      checkDateNow(data.appTime) &&
      parseInt(data.appStatus) <= 7 &&
      !data.telmdcnToDh &&
      data.telmdcnOpenYn === "Y" ? (
        <Button
          color={true}
          height="44px"
          style={{ flex: "1 0 0" }}
          onClick={() => {
            if (nftfConnect) {
              // alert('진료실에 입장중입니다. 잠시만 기다려주세요');
            } else {
              if (phonecfg.phoneOS === "ANDROID") {
                if (parseInt(phonecfg.version.split(".")[2]) > 85) {
                  setNftfConnect(true);
                }
              } else {
                if (parseInt(phonecfg.version.split(".")[2]) > 39) {
                  setNftfConnect(true);
                }
              }

              PostApi1970(userinfo, cfg, phonecfg, data.appID)
                .then((res) => {
                  if (res.resultCode === "E000") {
                    if (res.result[0].zoomSessId != "") {
                      postZoomSessionId(data.zoomSessId, cfg)
                        .then((res) => {
                          if (res && res.users && res.users.length > 0) {
                            if (res.users.length > 0) {
                              getAccessTokenApi(
                                data.hospital[0].hpCode.toString(),
                                data.appID.toString(),
                                data.hospital[0].hpName,
                                data.telmdcnFrDh,
                                userinfo,
                                phonecfg,
                                cfg
                              );
                            }
                          } else {
                            alert("진료실에 입장한 의료진이 없습니다.");
                            setNftfConnect(false);
                          }
                        })
                        .catch((err) => {
                          console.log("err :: ", err);
                        });
                    } else {
                      alert("진료실에 입장한 의료진이 없습니다.");
                      setNftfConnect(false);
                    }
                  }
                })
                .catch((err) => {
                  console.log("err :: ", err);
                });
            }
          }}
        >
          비대면진료실 들어가기
        </Button>
      ) : checkDateNow(data.appTime) ? (
        data.appCls == "1" && data.appStatus == "4" && data.telmdcnOpenYn === "N" ? (
          data.payStatus == "0" && (
            // data.amount == "0" && (
            <Fragment>
              <BottomShortBtn
                onClick={() =>
                  resrvCancelLayer(
                    data.hospital[0].hpName,
                    data.hospital[0].hpKey,
                    data.appID,
                    data.telmdcnOpenYn === "Y" ? "DEL" : "CNCL"
                  )
                }
              >
                예약취소
              </BottomShortBtn>

              <BottomShortBtn
                style={{
                  background: "#6B65DE",
                  color: "#fff",
                  flex: "1 0 0",
                  justifyContent: "center",
                }}
                onClick={() =>
                  handleConfirm(
                    "비대면 진료시간 확인",
                    "해당 시간에 비대면 진료를 받으겠습니까?",
                    data.appID
                  )
                }
              >
                네, 가능합니다
              </BottomShortBtn>
            </Fragment>
          )
        ) : data.appCls === "9" ? (
          data.appStatus != "3" && (
            <BottomShortBtn onClick={() => handleDialog("", "", "", data.hospital[0].phone)}>
              예약취소
            </BottomShortBtn>
          )
        ) : // ) : parseInt(data.appStatus) < 9 ? (
        parseInt(data.appStatus) <= 7 ? (
          <Fragment>
            {/* {data.telmdcnOpenYn === "Y" && data.telmdcnToDh && ( */}
            {(data.telmdcnOpenYn === "N" ||
              (data.telmdcnOpenYn === "Y" &&
                data.telmdcnToDh &&
                data.payStatus.toString() === "1")) && (
              <BottomShortBtn
                onClick={() =>
                  resrvCancelLayer(
                    data.hospital[0].hpName,
                    data.hospital[0].hpKey,
                    data.appID,
                    data.telmdcnOpenYn === "Y" &&
                      data.telmdcnToDh &&
                      data.payStatus.toString() === "1"
                      ? "DEL"
                      : "CNCL"
                  )
                }
              >
                {/* 예약삭제 */}
                {data.telmdcnOpenYn === "Y" && data.telmdcnToDh && data.payStatus.toString() === "1"
                  ? "예약삭제"
                  : "예약취소"}
              </BottomShortBtn>
            )}
          </Fragment>
        ) : (
          <BottomShortBtn
            onClick={() =>
              resrvCancelLayer(data.hospital[0].hpName, data.hospital[0].hpKey, data.appID, "DEL")
            }
          >
            {/* 예약삭제 */}
            예약삭제
          </BottomShortBtn>
        )
      ) : (
        <Fragment>
          <BottomShortBtn
            onClick={() =>
              resrvCancelLayer(data.hospital[0].hpName, data.hospital[0].hpKey, data.appID, "DEL")
            }
          >
            {/* 예약삭제 */}
            예약삭제
          </BottomShortBtn>
        </Fragment>
      )}
    </div>
  );
};

const skipTextCss = {
  color: "#6B65DE",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const defaultTextCss = {
  color: "#6B65DE",
};

const skipTextCssBlack = {
  color: "#333",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const defaultTextCssBlack = {
  color: "#333",
};

export default ReserveCard;
